import { cva } from '@/styled-system/css';

export const tabsListRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'stretch',
    marginBottom: 'negative-25',
    position: 'relative',
    zIndex: 1,
  },
  variants: {
    appearance: {
      default: {
        borderBottomWidth: 'default',
        borderBottomStyle: 'solid',
        borderBottomColor: 'Tabs.default.border.track',
      },
      file: {},
    },
    fluid: {
      true: {},
      false: {},
    },
  },
});
